export default __webpack_public_path__ + "static/KeywordResearch_02_02@2x-5b437ad7f67e5af370869c5aae1ac3c0.png";